import { render, staticRenderFns } from "./Installer.vue?vue&type=template&id=5dbcbdf4&"
import script from "./Installer.vue?vue&type=script&lang=js&"
export * from "./Installer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports